import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Department } from 'it/primatoo/openapi/api/org/schemas/permissionrule/permissionrule/Department';
import { ApiClientConfig } from './api-client-config';
import { CreateResponse } from 'it/primatoo/openapi/api/common/schemas/CreateResponse';
import { GetDepartmentForDetailsResponse } from 'it/primatoo/openapi/api/org/schemas/department/GetDepartmentForDetailsResponse';
import { CreateDepartmentRequest } from 'it/primatoo/openapi/api/org/schemas/department/CreateDepartmentRequest';
import { UpdateDepartmentRequest } from 'it/primatoo/openapi/api/org/schemas/department/UpdateDepartmentRequest';
import { ListDepartmentForMenuResponse } from 'it/primatoo/openapi/api/org/schemas/department/ListDepartmentForMenuResponse';
import { DataProtectionGovernanceService } from './interface/data-protection-governance-service';
import { PriorityPatchRequest } from '@primatoo-ms-organization';

@Injectable({
  providedIn: 'root',
})
export class DepartmentService extends DataProtectionGovernanceService {
  private readonly endpointV1: string;
  private readonly endpointV2: string;

  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpointV1 = this.config.endPoint + '/api/org/departments/';
    this.endpointV2 = this.config.endPoint + '/api/org/v2/departments/';
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<Department> {
    const url = `${this.endpointV1}${id}/priority`;
    return this.httpClient.patch<Department>(url, request);
  }

  getEndPointV1(): string {
    return this.endpointV1;
  }

  // V1
  public getDepartment(): Observable<Department[]> {
    const url = this.endpointV1;
    return this.httpClient.get<Department[]>(url);
  }

  // V2
  public getDetails(id: number): Observable<GetDepartmentForDetailsResponse> {
    const url = this.endpointV2 + `${id}/details/`;
    return this.httpClient.get<GetDepartmentForDetailsResponse>(url);
  }

  public findAllForMenu(): Observable<ListDepartmentForMenuResponse> {
    const url = this.endpointV2 + `menu/`;
    return this.httpClient.get<ListDepartmentForMenuResponse>(url);
  }

  public create(request: CreateDepartmentRequest): Observable<CreateResponse> {
    const url = this.endpointV2;
    return this.httpClient.post<CreateResponse>(url, request);
  }

  public update(
    id: number,
    request: UpdateDepartmentRequest
  ): Observable<void> {
    const url = this.endpointV2 + `${id}/`;
    return this.httpClient.put<void>(url, request);
  }
}
